import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-table-orange',
  templateUrl: './table-orange.component.html',
  styleUrls: ['./table-orange.component.css']
})
export class TableOrangeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
